import { LoopUpdatePriority } from './LoopUpdatePriority';

export const MaxTicks: number = 1 << LoopUpdatePriority.IDLE; // 2^5 = 32
